import {FormControl, FormGroup} from '@angular/forms';
import moment from 'moment';


export class CommonValidators {

//  Validation for only alphabetic characters
  static alpha(c: FormControl) {
    const alpha = /^[a-zA-Z]*$/;

    return alpha.test(c.value) ? null : {
      alpha: {
        valid: false
      }
    };
  }

//  Validation for only numeric characters
  static numeric(c: FormControl) {
    const numeric = /^[0-9]*$/;

    return c.value == 0 || c.value === null || numeric.test(c.value) ? null : {
      numeric: {
        valid: false
      }
    };
  }

//  Validation for currency
// https://stackoverflow.com/a/11780743
  static currency(c: FormControl) {
    const currency = /^[0-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
    return c.value == 0 || c.value === null || currency.test(c.value) ? null : {
      currency: {
        valid: false
      }
    };
  }

//  Validation for currency with tenths of cents (3 decimal places)
// https://stackoverflow.com/a/11780743
  static currency3dp(c: FormControl) {
    const currency = /^[0-9]\d*(((,\d{3}){1})?(\.\d{0,3})?)$/;
    return c.value == 0 || c.value === null || currency.test(c.value) ? null : {
      currency3dp: {
        valid: false
      }
    };
  }


  //  Validation for only numeric characters and must 6 digit
  static numericRequestNumber(c: FormControl) {
    const numeric = /^[0-9]{6}/;
    if (c.value) {
      return numeric.test(c.value) ? null : {
        numeric: {
          valid: false
        }
      };
    }
  }

//  Validation for alphanumeric characters
  static alphaNumeric(c: FormControl) {
    const alphaNumeric = /^[a-zA-Z0-9]*$/;

    return alphaNumeric.test(c.value) ? null : {
      alphaNumeric: {
        valid: false
      }
    };
  }

//  Validation for alphanumeric characters
  static alphaNumericSpace(c: FormControl) {
    const alphaNumeric = /^[a-zA-Z0-9\s]*$/;

    return alphaNumeric.test(c.value) ? null : {
      alphaNumericSpace: {
        valid: false
      }
    };
  }

//  Validation for firstLastNames
  static firstLastName(c: FormControl) {
    const firstLastName = /^[a-zA-Z0-9\-.\s]*$/;

    return firstLastName.test(c.value) ? null : {
      firstLastName: {
        valid: false
      }
    };
  }

//  Validation for Zip Code
  static zipCode(c: FormControl) {
    const zipCode = /^[0-9]{5}$/;

    return zipCode.test(c.value) ? null : {
      zipCode: {
        valid: false
      }
    };
  }

//  Validation for phone number (10)
  static phoneNumber(c: FormControl) {
    const phoneNumber = /^[0-9]{10}$/;

    return phoneNumber.test(c.value) ? null : {
      phoneNumber: {
        valid: false
      }
    };
  }


  //  Validation for phone number (10) and not required field
  static phoneNumberNotRequired(c: FormControl) {
    const phoneNumber = /^[0-9]{10}$/;
    if (c.value) {
      return phoneNumber.test(c.value) ? null : {
        phoneNumber: {
          valid: false
        }
      };
    }

  }

  //  Validation for reservation number (10)
  static reservationNumber(c: FormControl) {
    const reservationNumber = /^[a-zA-Z0-9\s-#]{5}$/;  // adding 5 min but maximum is 15

    return reservationNumber.test(c.value) ? null : {
      reservationNumber: {
        valid: false
      }
    };
  }

//  Validation for ????
  static address(c: FormControl) {
    const address = /^[a-zA-Z0-9\s-#.@/*]*$/;

    return address.test(c.value) ? null : {
      address: {
        valid: false
      }
    };
  }


// email
// from http://emailregex.com/
  static email(c: FormControl) {
    //
    const email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailWithSpaces = /^\s*(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/;
    if (c.value) {
      return email.test(c.value) || emailWithSpaces.test(c.value) ? null : {email: {valid: false}};
    }
  }

// email validation for certain category
  static specialEmail(c: FormControl) {
    // TODO for testing relaxing rules
    // const pattern =  /^([\w-.]+@(?!yahoo\.com)(?!hotmail\.com)(?!msn\.com)(?!verizon\.com)(?!cox\.com)([\w-]+.)+[\w-]{2,4})?$/;
    const pattern = /^([\w-.]+@(?!verizon\.com)(?!cox\.com)([\w-]+.)+[\w-]{2,4})?$/;

    if (c.value) {
      return pattern.test(c.value) ? null : {pattern: {valid: false}};
    }
  }

// zipcode
// zipcode length validation check
  static lengthFive(c: FormControl) {
    const localData = c.value;
    if (localData !== null && localData !== undefined) {
      if (localData.length === 5) {
        return null;
      } else {
        return {
          lengthFive: {valid: false}
        };
      }
    }
  }

// Zipcode validation
  static allZeros(c: FormControl) {
    if (c.value !== null && c.value !== undefined) {
      if (!(c.value === '00000')) {
        return null;
      } else {
        return {
          allZeros: {valid: false}
        };
      }
    }
  }

// Validation for ZipSuffix
  static lengthFour(c: FormControl) {
    const localData = c.value;
    if (localData !== null && localData !== undefined) {
      if (localData.length === 4) {
        return null;
      } else {
        if (localData.length === 0) {
          return null;
        } else {
          return {
            lengthFour: {valid: false}
          };
        }
      }
    }
  }

  static same(firstString: FormControl) {
    return function (c: FormControl) {
      let valueToReturn = null;
      if (firstString.value && firstString.value.length > 0) {
        if (firstString.value !== c.value) {
          valueToReturn = {same: {valid: false}};
        }
      }
      return valueToReturn;
    };
  }

  static checkDuplicateCCEmail(group: FormGroup) {
    let duplicateFound = false;
    const controlNames: string[] = ['emailCC1', 'emailCC2', 'emailCC3', 'emailCC4', 'emailCC5'];

    for (let x = 0; x < 5; x++) {
      for (let y = 0; y < 5; y++) {
        if (!(x == y)) {
          if (!(group.get(controlNames[x]).value == '')) {
            if (group.get(controlNames[x]).value.toUpperCase() == group.get(controlNames[y]).value.toUpperCase()) {
              duplicateFound = true;
            }
          }
        }
      }
    }

    if (!duplicateFound) {
      return null;
    } else {
      return {checkDuplicateCCEmail: {valid: false}};
    }
  }

  static checkDuplicateMainEmail(group: FormGroup) {
    let duplicateFound = false;
    const controlNames: string[] = ['emailCC1', 'emailCC2', 'emailCC3', 'emailCC4', 'emailCC5'];

    for (let x = 0; x < 5; x++) {
      if (!(group.get(controlNames[x]).value == '')) {
        if (group.get(controlNames[x]).value == group.parent.get('email').value) {
          duplicateFound = true;
        }
      }
    }

    if (!duplicateFound) {
      return null;
    } else {
      return {checkDuplicateMainEmail: {valid: false}};
    }
  }

  static promote(arr) {
    const usa = {
      stateCountryId: 326,
      stateCountryType: 'Country',
      stateCountryCode: 'US00',
      stateCountryCode2Digit: 'US',
      stateCountryName: 'UNITED STATES',
      schedule: '0',
      deptOfState: 0,
      serviceAreaId: null,
      parentCountryId: null,
      contiguousUS: 0,
      updateProgram: '',
      updateId: null,
      updateDate: '2019-05-10T14:36:12.000+0000'
    };
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].stateCountryCode === usa.stateCountryCode) {
        const a = arr.splice(i, 1);   // removes the item
        arr.unshift(a[0]);         // adds it back to the beginning
        break;
      }
    }
    // Matching item wasn't found. Array is unchanged, but you could do something
    // else here if you wish (like an error message).
    return arr;
  }

  static usDate(control: FormControl): { [key: string]: any } {
    if(moment(control.value,'MM/DD/YYYY',true).isValid()) return { "validDateTime": false };
    return { "validDateTime": true };
  }
}
